// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileTextarea_wrapper__57QdR","registeredInput":"ProfileTextarea_registeredInput__kAzM1","label":"ProfileTextarea_label__DKwea"};